// Mantine
import { Button } from '@mantine/core'

// Icons
import { Plus } from '@untitled-ui/icons-react'

// React Router
import { Link } from 'react-router-dom'

// UI
import FulfillmentOrdersTable from '@/components/fulfillment_orders/FulfillmentOrdersTable'
import Breadcrumbs from '@/components/ui/Breadcrumbs'

export default function IndexFulfillmentOrders() {
    const layoutProps = {
        breadcrumbs: [
            {
                label: 'Demandes de préparations',
            },
        ],
        rightSection: (
            <div className="flex gap-2">
                <Link to="/fulfillment_orders/create">
                    <Button variant="light" color="dark" leftSection={<Plus width={14} height={14} />}>Créer une demande de préparation</Button>
                </Link>
            </div>
        ),
    }

    return (
        <div>
            <Breadcrumbs {...layoutProps} />
            <FulfillmentOrdersTable />
        </div>
    )
}